'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const DefaultAvailableDutyStatuses=['RSV','CU'];
const ControllerDefaultBindings={
availableDutyStatuses:DefaultAvailableDutyStatuses.slice(),
selectedDutyStatuses:DefaultAvailableDutyStatuses.slice(),
isMinimized:!1};let



DutyStatusSelectorController=function(){
function DutyStatusSelectorController($scope,$timeout,displaySettingsService){_classCallCheck(this,DutyStatusSelectorController);
this._$scope=$scope;
this._$timeout=$timeout;
this._displaySettingsService=displaySettingsService;

_.defaults(this,this._getStoredStickyStatuses(),ControllerDefaultBindings);

this.addActivityCode=this._addActivityCode.bind(this);

this._createStatusWatcher('availableDutyStatuses');
this._createStatusWatcher('selectedDutyStatuses');
}DutyStatusSelectorController.prototype.

_getStoredStickyStatuses=function _getStoredStickyStatuses(){
return{
availableDutyStatuses:_.toArray(this._displaySettingsService.stickySettings.get('availableDutyStatuses')),
selectedDutyStatuses:_.toArray(this._displaySettingsService.stickySettings.get('selectedDutyStatuses'))};

};DutyStatusSelectorController.prototype.

_createStatusWatcher=function _createStatusWatcher(fieldName){var _this=this;
this._$scope.$watchCollection(`controller.${fieldName}`,function(statuses){
if(!_.exists(statuses)){
return;
}

if(statuses.length===0&&fieldName==='availableDutyStatuses'){
console.warn('Preventing zero available duty statuses from being assigned.');
_this._resetDefaultAvailableDutyStatuses();
return;
}

const currentValues=_.toArray(_this._displaySettingsService.stickySettings.get(fieldName));
if(_.isEqual(_.sortBy(currentValues,_.identity),_.sortBy(statuses,_.identity))){
return;
}

_this._displaySettingsService.stickySettings.set(fieldName,new Set(statuses));
});
};DutyStatusSelectorController.prototype.

_addActivityCode=function _addActivityCode(newActivityCode){var _this2=this;
this._$timeout(function(){
_this2.selectedDutyStatuses.push(newActivityCode);
_this2.availableDutyStatuses=_.uniq(_this2.availableDutyStatuses.concat(newActivityCode));
});
};DutyStatusSelectorController.prototype.

_resetDefaultAvailableDutyStatuses=function _resetDefaultAvailableDutyStatuses(){var _this3=this;
this._$timeout(function(){
_this3.availableDutyStatuses=DefaultAvailableDutyStatuses.slice();
});
};return DutyStatusSelectorController}();let


DutyStatusSelectorDirective=function(_BaseControllerBacked){_inherits(DutyStatusSelectorDirective,_BaseControllerBacked);function DutyStatusSelectorDirective(){_classCallCheck(this,DutyStatusSelectorDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DutyStatusSelectorDirective,[{key:'templateUrl',get:function()
{return'/templates/features/emirates/emiratesDashboard/components/dutyStatusSelectorDirective/dutyStatusSelectorTemplate'}},{key:'objectBindings',get:function()

{return['isMinimized','selectedDutyStatuses']}},{key:'controller',get:function()

{return DutyStatusSelectorController}}]);return DutyStatusSelectorDirective}(BaseControllerBackedDirective);


module.exports=DutyStatusSelectorDirective;
module.exports.DefaultAvailableDutyStatuses=DefaultAvailableDutyStatuses;
//# sourceMappingURL=dutyStatusSelectorDirective.js.map
